import {React, useEffect} from "react";
import ColorInit from "../../helper/ColorInit";
import ScrollToTop from "react-scroll-to-top";
import Preloader from "../../helper/Preloader";
import HeaderGuest from "../../components/layout/HeaderGuest";
import FooterOne from "../../components/layout/FooterOne";
import BottomFooter from "../../components/layout/BottomFooter";

import AdminFormRegistration from "../../components/seller-registration/adminregistration/FirstTimeRegistration";
// import FirstTimeRegistration from "../../components/seller-registration/FirstTimeRegistration";
import CounterSection from "../../components/seller-registration/CounterSection";
import Steps from "../../components/seller-registration/StepsRegistration";


const AdminSellerRegistration = () => {

   useEffect(() => {
        document.title = "iWant Seller Registration";
    }, []);
  return (
    <>
      {/* ColorInit */}
      <ColorInit color={false} />

      {/* ScrollToTop */}
      <ScrollToTop smooth color='#990A02' />

      {/* Preloader */}
      <Preloader />

    <HeaderGuest />
      
    <AdminFormRegistration />

    <Steps />

    <CounterSection />


      {/* FooterTwo */}
      <FooterOne />

      {/* BottomFooter */}
      <BottomFooter />
    </>
  );
};

export default AdminSellerRegistration;